import { request } from '../../utils/request';

export const removeProductImage = (
  productId: number,
  fileId: number,
  authToken: string
) =>
  request({
    method: 'DELETE',
    url: `/products/${productId}/images/${fileId}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
